// const baseUrl = "http://vdoc.nexilo.in";
// export const baseUrl = "http://localhost:3000";
export const baseUrl = "https://vdoc.nexilo.in";
export const apiBaseUrl = `${baseUrl}/api`;
export const imageBaseUrl = `${baseUrl}/storage/`;
export const defaultCurrency = "₹";
export const agoraAppId = "5a455482564a45449107ef9de097f288";

// Normal user
export const registerUser = "/user/registerUser";
export const updateUserDetais = "/user/updateUserDetails";
export const doctorProfiles = "/user/fetchDoctorProfile";
export const fetchHomePageData = "/user/fetchHomePageData";
export const searchDoctor = "/user/searchDoctor";
export const fetchDoctorCategories = "/fetchDoctorCategories";
export const fetchDoctorProfile = "/user/fetchDoctorProfile";
export const fetchGlobalSettings = "/fetchGlobalSettings";
export const fetchDoctorReviews = "/user/fetchDoctorReviews";
export const fetchAcceptedPendingAppointmentsOfDoctorByDate = "/user/fetchAcceptedPendingAppointmentsOfDoctorByDate";
export const fetchCoupons = "/user/fetchCoupons";
export const fetchMyUserDetails = "/user/fetchMyUserDetails";
export const fetchFavoriteDoctors = "/user/fetchFavoriteDoctors";
export const fetchWalletStatement = "/user/fetchWalletStatement";
export const fetchMyAppointments = "/user/fetchMyAppointments";
export const fetchAppointmentDetails = "/user/fetchAppointmentDetails";
export const fetchPatients = "/user/fetchPatients";
export const addPatient = "/user/addPatient";
export const editPatient = "/user/editPatient";
export const addAppointment = "/user/addAppointment";
export const rescheduleAppointment = "/user/rescheduleAppointment";
export const uploadFileGivePath = "/uploadFileGivePath";
export const getAgoraToken = "/generateAgoraToken";
export const makeRechargeRequest = "/user/makeRechargeRequest";

// Doctor Routes
export const doctorRegistration = "/doctorRegistration";
export const updateDoctorDetails = "/updateDoctorDetails";
export const fetchDoctorServicesList = "/fetchDoctorServicesList";
export const addEditService = "/addEditService";
export const addEditExpertise = "/addEditExpertise";
export const addEditExperience = "/addEditExperience";
export const addEditServiceLocations = "/addEditServiceLocations";
export const addEditAwards = "/addEditAwards";
export const deleteService = "/deleteService";
export const addAppointmentSlots = "/addAppointmentSlots";
export const deleteAppointmentSlot = "/deleteAppointmentSlot";
export const deleteHoliday = "/deleteHoliday";
export const addHoliday = "/addHoliday";
export const fetchDoctorWalletStatement = "/fetchDoctorWalletStatement";
export const manageDrBankAccount = "/manageDrBankAccount";
export const fetchAppointmentRequests = "/fetchAppointmentRequests";
export const addPrescription = "/addPrescription";
export const editPrescription = "/editPrescription";
export const acceptAppointment = "/acceptAppointment";
export const declineAppointment = "/declineAppointment";
export const completeAppointment = "/completeAppointment";
